import { Option, Select } from "@mui/joy";

import type { MaterialLineItemOption } from "../../../types";
import { ProductOptionContent, ProductSelectValue } from "./ProductOptionContent";

export type MaterialProductSelectProps = {
    products: MaterialLineItemOption[];
    value: string | null;
    onChange?: (productId: string | null) => void;
    placeholder?: string;
};

export default function MaterialProductSelect({
    products,
    value,
    onChange,
    placeholder = "Select product…",
}: MaterialProductSelectProps) {
    const selected = products.find((p) => p.ProductId === value);

    return (
        <Select
            size="sm"
            placeholder={placeholder}
            value={value}
            onChange={(_, next) => onChange?.(next as string | null)}
            renderValue={() =>
                selected ? <ProductSelectValue product={selected} /> : null
            }
            slotProps={{
                listbox: {
                    sx: {
                        minWidth: 320,
                        "--ListItem-paddingY": "6px",
                    },
                },
            }}
            sx={{
                width: "100%",
                bgcolor: "background.surface",
                borderRadius: "4px",
                boxShadow: "none",
            }}
        >
            {products.map((product) => (
                <Option key={product.ProductId} value={product.ProductId}>
                    <ProductOptionContent product={product} />
                </Option>
            ))}
        </Select>
    );
}
